var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBobaAvatar0(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4535208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#C07C62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.18199 22.2829C9.34063 22.2829 11.0906 20.533 11.0906 18.3744C11.0906 16.2157 9.34063 14.4658 7.18199 14.4658C5.02336 14.4658 3.27344 16.2157 3.27344 18.3744C3.27344 20.533 5.02336 22.2829 7.18199 22.2829Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.6625 15.7712C21.8211 15.7712 23.571 14.0213 23.571 11.8627C23.571 9.70402 21.8211 7.9541 19.6625 7.9541C17.5038 7.9541 15.7539 9.70402 15.7539 11.8627C15.7539 14.0213 17.5038 15.7712 19.6625 15.7712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.1761 12.3348C21.5831 10.832 20.6948 9.28366 19.1919 8.87664C17.689 8.46961 16.1407 9.35798 15.7337 10.8609C15.3267 12.3637 16.215 13.912 17.7179 14.319C19.2208 14.7261 20.7691 13.8377 21.1761 12.3348Z",
    fill: "#D79B7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.71494 18.9614C9.12645 17.451 8.23559 15.8929 6.72515 15.4814C5.21471 15.0699 3.65664 15.9608 3.24513 17.4712C2.83362 18.9817 3.7245 20.5397 5.23494 20.9512C6.74538 21.3627 8.30343 20.4719 8.71494 18.9614Z",
    fill: "#D79B7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M35.962 24.6379C36.6788 24.6379 37.2599 24.0568 37.2599 23.3399C37.2599 22.6231 36.6788 22.042 35.962 22.042C35.2452 22.042 34.6641 22.6231 34.6641 23.3399C34.6641 24.0568 35.2452 24.6379 35.962 24.6379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M34.503 20.062C34.6357 18.7353 34.2498 17.4086 33.4263 16.36L31.0074 12.2892C30.7278 11.9337 30.591 11.4866 30.624 11.0355C30.7216 10.7565 30.9181 10.5229 31.1763 10.3788C31.4344 10.2348 31.7364 10.1903 32.0251 10.2538C32.5956 10.4079 33.1083 10.7258 33.5001 11.1682C34.5261 12.1633 35.383 13.3191 36.0369 14.5901C36.6002 15.5427 36.8672 16.6415 36.8039 17.7464C36.7584 18.2952 36.5396 18.8154 36.179 19.2317C35.8184 19.648 35.3348 19.9388 34.798 20.062H34.503Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBobaAvatar0);
export default __webpack_public_path__ + "static/media/boba-avatar-0.d7c8877a.svg";
export { ForwardRef as ReactComponent };